export default __webpack_public_path__ + "static/media/qr.4d604ba5.png";